import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'
import store from '@/store'

export default {

    path: '/staff',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['staff'] },
    component: () => import('../components/pages/staff/StaffGeneral.vue'),
    children: [
        {
            path: '',
            redirect: () => {
                if(store.state.auth.rights.includes('doctors_page')) return { path: '/staff/doctors' }
                return { path: '/staff/technics' }
            }
        },
        {
            path: 'doctors', name: "StaffDoctors",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['doctors_page', 'staff'] },
            component: () => import('@/components/pages/staff/Doctors.vue')
        },
        {
            path: 'assistants', name: "StaffAssistants",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['doctors_page', 'staff', 'assistants'] },
            component: () => import('@/components/pages/staff/Assistants.vue')
        },
        {
            path: 'administrators', name: "StaffAdministrators",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['create_admin','staff'] },
            component: () => import('@/components/pages/staff/Administrators.vue')
        },
        {
            path: 'curators', name: "StaffCurators",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['staff', 'curators'] },
            component: () => import('@/components/pages/staff/Curators.vue')
        },
        {
            path: 'technics', name: "StaffTechnics",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['staff'] },
            component: () => import('@/components/pages/staff/Technics.vue')
        },
        {
            path: 'chairs', name: "StaffChairs",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['create_chairs', 'staff'] },
            component: () => import('@/components/pages/staff/Chairs.vue')
        },
        {
            path: 'roles', name: "StaffRoles",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['staff_roles', 'staff'] },
            component: () => import('@/components/pages/staff/StaffRoles.vue')
        },
        {
            path: 'doctors/:id',
            meta: { middleware: [authorized, paid], layout: "default", rights: ['doctors_page'] },
            component: () => import('../components/pages/staff/DoctorGeneral.vue'),
            children: [
                { path: '', redirect: '/doctors/:id/visits' },
                {
                    path: 'visits', name: "StaffDoctorVisits",
                    meta: { middleware: [authorized, paid], layout: "default" },
                    component: () => import('@/components/pages/staff/DoctorVisits.vue')
                },
                {
                    path: 'schedule', name: "StaffDoctorSchedule",
                    meta: { middleware: [authorized, paid], layout: "default", rights: ['work_time_edit'] },
                    component: () => import('@/components/pages/staff/DoctorSchedule.vue')
                },
                {
                    path: 'feedbacks', name: "StaffDoctorFeedbacks",
                    meta: { middleware: [authorized, paid], layout: "default", rights: ['view_feedbacks'] },
                    component: () => import('@/components/pages/staff/DoctorFeedbacks.vue')
                },

            ]
        },

    ]

}
